export const blockIconsPrivacyandsecurityShieldNew = (
	<span className='material-symbols-outlined'>shield</span>
);
